import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import PropTypes from "prop-types";

import ArrowEast from "../assets/icons/east.svg";
import StartPoint from "../assets/icons/startPoint.svg";
import Elevator from "../assets/icons/elevator.svg";
import North from "../assets/icons/north.svg";
import KakaoIcon from "../assets/icons/kakaoIcon.svg";
import EndPoint from "../assets/icons/endPoint.svg";
import BtnSeeMap from "../assets/icons/btnSeeMap.svg";
import BtnSeePath from "../assets/icons/btnSeePath.svg";
import DeleteMiniMap from "../assets/buttons/clear_minimap.svg";
import iconArrowLeft from "../assets/icons/path_arrow_left.svg";
import iconArrowUp from "../assets/icons/path_arrow_up.svg";
import iconEscalator from "../assets/icons/path_escalator.svg";
import iconExhibition from "../assets/icons/path_exhibition.svg";
import iconStair from "../assets/icons/path_stair.svg";
import iconShuttle from "../assets/icons/shuttle.svg";

import { useTranslation } from "react-i18next";
import styled from "styled-components";

const BtnShuttleInfo = styled(Link)`
  color: var(--primary-1-primary, #066aeb);
  text-align: right;
  font-feature-settings: "liga" off, "clig" off;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */

  display: flex;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  text-align: center;
  text-decoration: none;
  transition: background-color 0.3s ease;
  font-size: 12px;
  color: #066aeb;
  border-radius: 4px;
  border: 1px solid var(--primary-1-primary, #066aeb);

  &:hover {
    background-color: #2563eb;
  }
`;

const BtnNavigate = styled.button`
  color: var(--neutral-1-on-background-on-surface, #262d39);
  text-align: right;
  font-feature-settings: "liga" off, "clig" off;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;

  display: flex;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: #ffffff;

  text-decoration: none;

  border-radius: 4px;
  border: 1px solid
    var(--neutral-5-on-background-on-surface, rgba(38, 45, 57, 0.16));
`;

const showWalkPath = (e, kakaoLink) => {
  e.preventDefault();
  window.open(kakaoLink); // open a link in new tab
};

const PathList = ({ pathDetails }) => {
  const { t, i18n } = useTranslation();
  console.log("pathDetail: ", pathDetails);
  return (
    <div style={{ minHeight: `${64 * pathDetails.length + 88}px` }}>
      {pathDetails.map((path, index) => {
        return (
          <div key={index}>
            {index > 0 && (
              <div
                style={{
                  backgroundColor: "#EEEFF3",
                  height: "1px",
                  width: "calc(100vw - 32px)",
                }}
              />
            )}
            <table
              style={{
                margin: "-2px 0",
                fontSize: "14px",
              }}
            >
              <colgroup>
                <col />
                <col />
                <col />
                {/* {path.btn !== "" && <col />} */}
              </colgroup>
              <tbody>
                <tr>
                  <td style={{ padding: "13px 0", height: "32px" }}>
                    {console.log("path.icon: ", path.icon)}
                    <img
                      src={
                        path.icon === "arrow_up"
                          ? iconArrowUp
                          : path.icon === "arrow_left"
                          ? iconArrowLeft
                          : path.icon === "stair"
                          ? iconStair
                          : path.icon === "escalator"
                          ? iconEscalator
                          : path.icon === "exhibition"
                          ? iconExhibition
                          : path.icon === "shuttle"
                          ? iconShuttle
                          : path.icon
                      }
                      alt=""
                    />
                  </td>
                  {path.hasOwnProperty("btn") ? (
                    <td
                      style={{
                        padding: "0 12px 0 12px",
                        width: "calc(100vw - 166px)",
                        height: "64px",
                        verticalAlign: "middle",
                      }}
                    >
                      {path.str[i18n.language]}
                    </td>
                  ) : (
                    <td
                      style={{
                        padding: "0 0 0 12px",
                        width: "calc(100vw - 76px)",
                        height: "64px",
                        verticalAlign: "middle",
                      }}
                    >
                      {path.str[i18n.language]}
                    </td>
                  )}

                  {path.btn !== undefined &&
                    path.btn.startsWith("shuttle-info-") && (
                      <td
                        style={{
                          position: "absolute",
                          right: 0,
                          padding: "16px 16px 0 0",
                        }}
                      >
                        <BtnShuttleInfo
                          to={`/shuttle-info?region=${path.btn.split("-")[2]}`}
                        >
                          {/* <img src={BtnSeeMap} alt="" /> */}
                          {t("pathList.shuttleInfo")}
                        </BtnShuttleInfo>
                      </td>
                    )}
                  {path.btn === "start" && (
                    <td
                      style={{
                        position: "absolute",
                        right: 0,
                        padding: "16px 16px 0 0",
                      }}
                    ></td>
                  )}
                  {path.btn === "end" && (
                    <td
                      style={{
                        position: "absolute",
                        right: 0,
                        padding: "16px 16px 0 0",
                      }}
                    ></td>
                  )}
                  {path.btn === "map" && (
                    <td
                      style={{
                        position: "absolute",
                        right: 0,
                        padding: "16px 16px 0 0",
                      }}
                    >
                      <BtnNavigate
                        onClick={(e) => {
                          showWalkPath(e, path.url);
                        }}
                      >
                        {t("pathList.navigate")}
                      </BtnNavigate>
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
};
PathList.propTypes = {
  pathDetails: PropTypes.array,
};

export default PathList;
